"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradeOrderMap = void 0;
exports.GradeOrderMap = [
    {
        Grade: 'C/AB',
        GradeOrder: 0,
    },
    {
        Grade: 'CADET',
        GradeOrder: 0,
    },
    {
        Grade: 'C/Amn',
        GradeOrder: 1,
    },
    {
        Grade: 'C/A1C',
        GradeOrder: 2,
    },
    {
        Grade: 'C/SrA',
        GradeOrder: 3,
    },
    {
        Grade: 'C/SSgt',
        GradeOrder: 4,
    },
    {
        Grade: 'C/TSgt',
        GradeOrder: 5,
    },
    {
        Grade: 'C/MSgt',
        GradeOrder: 6,
    },
    {
        Grade: 'C/SMSgt',
        GradeOrder: 7,
    },
    {
        Grade: 'C/CMSgt',
        GradeOrder: 8,
    },
    {
        Grade: 'C/2dLt',
        GradeOrder: 9,
    },
    {
        Grade: 'C/1stLt',
        GradeOrder: 10,
    },
    {
        Grade: 'C/Capt',
        GradeOrder: 11,
    },
    {
        Grade: 'C/Maj',
        GradeOrder: 12,
    },
    {
        Grade: 'C/LtCol',
        GradeOrder: 13,
    },
    {
        Grade: 'C/Col',
        GradeOrder: 14,
    },
    {
        Grade: 'SM',
        GradeOrder: 20,
    },
    {
        Grade: 'SSgt',
        GradeOrder: 21,
    },
    {
        Grade: 'TSgt',
        GradeOrder: 22,
    },
    {
        Grade: 'MSgt',
        GradeOrder: 23,
    },
    {
        Grade: 'SMSgt',
        GradeOrder: 24,
    },
    {
        Grade: 'CMSgt',
        GradeOrder: 25,
    },
    {
        Grade: 'FO',
        GradeOrder: 30,
    },
    {
        Grade: 'TFO',
        GradeOrder: 31,
    },
    {
        Grade: 'SFO',
        GradeOrder: 32,
    },
    {
        Grade: '2d Lt',
        GradeOrder: 33,
    },
    {
        Grade: '1st Lt',
        GradeOrder: 34,
    },
    {
        Grade: 'Capt',
        GradeOrder: 35,
    },
    {
        Grade: 'Maj',
        GradeOrder: 36,
    },
    {
        Grade: 'Lt Col',
        GradeOrder: 37,
    },
    {
        Grade: 'Col',
        GradeOrder: 38,
    },
    {
        Grade: 'Brig Gen',
        GradeOrder: 39,
    },
    {
        Grade: 'Maj Gen',
        GradeOrder: 40,
    },
];
//# sourceMappingURL=gradeOrder.js.map